import { RELATIONSHIP_BASE_URL } from 'config';
import Cookies from 'universal-cookie';

export const RELATIONSHIP_REDIRECT_COOKIE_NAME = 'relationship_redirect_to';
export const COOKIE_PATH = process.env.NODE_ENV === 'development' ? '/' : '/hotels/manage';

const login = (pathname: string) => {
  const cookies = new Cookies();
  cookies.set(RELATIONSHIP_REDIRECT_COOKIE_NAME, `${RELATIONSHIP_BASE_URL}${pathname}`, { path: COOKIE_PATH });

  window.location.href = `${RELATIONSHIP_BASE_URL}/login`;
};

export default login;
